import { render, staticRenderFns } from "./NewEmployeeModal.vue?vue&type=template&id=21b3a278&scoped=true&"
import script from "./NewEmployeeModal.vue?vue&type=script&lang=js&"
export * from "./NewEmployeeModal.vue?vue&type=script&lang=js&"
import style0 from "./NewEmployeeModal.vue?vue&type=style&index=0&id=21b3a278&scoped=true&lang=scss&"
import style1 from "./NewEmployeeModal.vue?vue&type=style&index=1&id=21b3a278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3a278",
  null
  
)

export default component.exports